module.exports = __webpack_public_path__ + "static/img/analysis.fc2c5e73.jpg";